import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import { cn } from "@/lib/utils";
import { ImageRowComponent } from "./ImageRowNodeView";

export const ImageRow = Node.create({
  name: "imageRow",

  group: "block",
  content: "image*",
  defining: true,
  isolating: true,

  addAttributes() {
    return {
      align: {
        default: "left",
        parseHTML: (element) => element.getAttribute("data-align") || "left",
        renderHTML: (attributes) => ({
          "data-align": attributes.align,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-image-row]",
      },
    ];
  },

  renderHTML({ HTMLAttributes, node }) {
    const align = (node.attrs.align as string) || "left";
    const justifyClass =
      align === "center"
        ? "justify-center"
        : align === "right"
          ? "justify-end"
          : "justify-start";

    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-image-row": "true",
        class: cn(
          "my-4 flex flex-wrap items-start gap-3 rounded-xl border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-700 dark:bg-slate-900/70",
          justifyClass,
        ),
      }),
      0,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageRowComponent);
  },
});
